import React from 'react';

const Alignment = () => {
  return (
    <section>
      <h2 className="section-title">The Power of Value Alignment</h2>
      <div className="section-card">
        <div className="alignment-container">
          <div className="alignment-column">
            <h3>When aligned with values</h3>
            <ul>
              <li>Greater sense of authenticity and purpose</li>
              <li>Enhanced psychological well-being</li>
              <li>More consistent decision-making</li>
              <li>Increased resilience during challenges</li>
              <li>Deeper satisfaction with life choices</li>
            </ul>
          </div>
          <div className="alignment-column">
            <h3>When misaligned with values</h3>
            <ul>
              <li>Experience of cognitive dissonance</li>
              <li>Feelings of inauthenticity or unease</li>
              <li>Internal conflict and stress</li>
              <li>Decreased motivation and engagement</li>
              <li>Sense of being off-track in life</li>
            </ul>
          </div>
        </div>
        <div className="quote-box">
          <p>
            "When your behaviors align with your core values, you typically experience greater 
            authenticity and well-being. When there's misalignment, you might experience what 
            psychologists call 'cognitive dissonance' - a form of psychological tension that 
            often signals a need to reassess either your actions or your values."
          </p>
        </div>
      </div>
    </section>
  );
};

export default Alignment;